module.exports = "images/12ans.0209262a.png";